import React from 'react';
import GameAddEdit from '../../../components/admin/GameAddEdit/GameAddEdit';
import styles from './AdminGameCreate.module.scss';
const AdminGameCreate = () => {
  return <GameAddEdit />;
};

export default AdminGameCreate;
